import React, { useCallback, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import peopleSvG from '~/assets/images/people.svg';
import bugSVG from '~/assets/images/bug.svg';
import { getCurrentLanguage } from '../app.i18n';
import { VideoPlayer, Video } from '~/app/shared';
import './home.module.scss';

export default function Home() {
  const [showMore, setShowMore] = useState<boolean>();
  const [t] = useTranslation();
  const language = getCurrentLanguage();

  const toggleText = useCallback(() => {
    setShowMore(!showMore);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [showMore]);

  const asset: Video = {
    tracks: [
      {
        default: true,
        srcLang: t('home.video.track.srcLang'),
        url: t('home.video.track.url')
      }
    ],
    sources: [
      {
        url: t('home.video.source.mp4'),
        type: 'video/mp4'
      },
      {
        url: t('home.video.source.ogv'),
        type: 'video/ogg'
      },
      {
        url: t('home.video.source.webm'),
        type: 'video/webm'
      }
    ]
  };

  return (
    <div styleName={`home ${showMore ? 'is-show-more' : ''}`} className="app-bg_static">
      <Container styleName="home-wrapper">
        <div styleName="home-container">
          <div styleName={`home-animate_text ${showMore ? 'is-hidden' : ''}`}>
            <h1 styleName="home-title">{t('home.title')}</h1>
            <div styleName="home-paragraph">{t('home.information')}</div>
          </div>

          <div styleName={`home-animate_text ${showMore ? '' : 'is-hidden'}`}>
            <div styleName="home-paragraph is-show-more">{t('home.first-explanation')}</div>
            <div styleName="home-paragraph is-show-more">
              <span styleName="home-bold">{t('home.do-not-worry')} </span>
              {t('home.second-explanation')}
            </div>
          </div>

          <div styleName="home-row" className="mb-4">
            <span styleName="home-text">{t('home.believe-text')}</span>
          </div>
          <Button
            styleName="home-confused"
            aria-label={!showMore ? t('home.know-more') : t('home.go-back')}
            variant="link"
            onClick={toggleText}
          >
            {!showMore ? t('home.know-more') : t('home.go-back')}
          </Button>
          <Link className="btn btn-primary" styleName="home-start" to={`/${language}/quiz`}>
            {t('home.start-quiz')}
          </Link>
        </div>
        <div styleName="home-video">
          <VideoPlayer thumbnail staticWidth video={asset} autoHeight />
          <div styleName="home-video_title">
            <span styleName="home-video__label">{t('home.video.title')}</span>
            <span styleName="home-video__label is_desktop">
              {t('home.video.sourceName')}
              <a styleName="home-video_link" href={t('home.video.link')}>
                {t('home.video.linkValue')}
              </a>
            </span>
          </div>
        </div>
      </Container>
      <div styleName={`home-img_container ${showMore ? 'is-mobile-hidden' : ''}`}>
        <img src={peopleSvG} styleName="home-people" alt="People investigating" />
        <img src={bugSVG} styleName="home-bug" alt="People investigating" />
      </div>
    </div>
  );
}
